export default {
  getMobile(state) {
    return state.isMobile;
  }
}